<div class="container mb-5">
  <div class="text-center">
  <h4 class="mt-5 mb-2">Accesso al servizio in corso</h4>
    <p class="mb-5">Verrai reindirizzato al servizio selezionato a breve</p>
<div class="loader m-auto">
  <div class="orbe" style="--index: 0"></div>
  <div class="orbe" style="--index: 1"></div>
  <div class="orbe" style="--index: 2"></div>
  <div class="orbe" style="--index: 3"></div>
  <div class="orbe" style="--index: 4"></div>
</div>
    <p class="mt-5">Se sei bloccato su questa pagina, puoi tornare alla <a (click)="goToHome()" class="text-decoration-underline link-primary">home</a></p>
  </div>
</div>
